<template>
  <div class="row">
    <Loading v-if="showLoading" />
    <div
      :class="
        order.orderTypeId == 143 && $store.state.role != 'admin'
          ? 'col-md-12'
          : 'col-md-12'
      "
    >
      <div class="mb-3">
        <div class="card-body">
          <div class="row g-4 mb-4 align-items-start">
            <!-- ================= ردیف عملیات (تمام عرض، دکمه‌ها در سمت چپ) ================= -->
            <div class="row mt-2 mb-4  col-12">
              <div class="col-12 pl-2">
                <div
                  class="d-flex flex-wrap gap-2 justify-content-end align-items-center p-3 bg-light rounded shadow-sm"
                  style="margin-left: 3rem;"
                >
                  <!-- عملیات قبلی در کارت عملیات -->
                  <button
                    v-if="
                      ($store.state.role == 'bankpublicrelations' ||
                        $store.state.role === 'izbank-admin') &&
                        order.flowStepStatusId == 183
                    "
                    class="btn btn-success"
                    @click="confirmAndExecute('approvePR')"
                  >
                    تایید روابط عمومی
                  </button>
                  <button
                    v-if="
                      ($store.state.role == 'bankpublicrelations' ||
                        $store.state.role === 'izbank-admin') &&
                        order.flowStepStatusId == 183
                    "
                    class="btn btn-danger"
                    @click="confirmAndOpenModal('#reject')"
                  >
                    عدم تایید روابط عمومی
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId == 184 &&
                        ($store.state.role == 'branches' ||
                          $store.state.role == 'izbank-admin')
                    "
                    class="btn btn-success"
                    @click="confirmAndExecute('customerApprove', 1)"
                  >
                    تایید طرح توسط مشتری
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId == 184 &&
                        ($store.state.role == 'branches' ||
                          $store.state.role == 'izbank-admin')
                    "
                    class="btn btn-danger"
                    @click="confirmAndExecute('customerApprove', 0)"
                  >
                    عدم تایید طرح توسط مشتری
                  </button>
                  <button
                    v-if="
                      $store.state.role == 'finance' &&
                        order.flowStepStatusId == 21 &&
                        !order.financeVerify
                    "
                    class="btn btn-success"
                    @click="confirmAndExecute('financialApprove')"
                  >
                    تاییدیه مالی
                  </button>
                  <button
                    v-if="
                      $store.state.role == 'finance' &&
                        order.flowStepStatusId == 21 &&
                        !order.financeVerify
                    "
                    class="btn btn-danger"
                    @click="confirmAndOpenModal('#finance-reject')"
                  >
                    عدم تایید مالی
                  </button>
                  <button
                    v-if="
                      $store.state.role == 'admin' &&
                        (order.flowStepStatusId == 31 ||
                          order.flowStepStatusId == 32)
                    "
                    class="btn btn-primary"
                    @click="confirmAndExecute('sent')"
                  >
                    ارسال شده
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId != 32 &&
                        order.flowStepStatusId != 21 &&
                        order.flowStepStatusId != 28 &&
                        ($store.state.role == 'branches' ||
                          $store.state.role == 'izbank-admin') &&
                        (order.flowStepStatusId == 8 ||
                          order.flowStepStatusId == 142)
                    "
                    class="btn btn-info"
                    @click="confirmAndExecute('delivered')"
                  >
                    تحویل شده
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId != 32 &&
                        order.flowStepStatusId != 21 &&
                        order.flowStepStatusId != 28 &&
                        ($store.state.role == 'branches' ||
                          $store.state.role == 'izbank-admin') &&
                        order.flowStepStatusId == 8
                    "
                    class="btn btn-danger"
                    @click="confirmAndExecute('notDelivered')"
                  >
                    تحویل نشده
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId != 32 &&
                        order.flowStepStatusId != 21 &&
                        order.flowStepStatusId != 28 &&
                        order.flowStepId == 43 &&
                        order.flowStepStatusId == 8 &&
                        false
                    "
                    class="btn btn-warning"
                    @click="confirmAndOpenModal('#refound')"
                  >
                    ثبت مرجوعی سفارش
                  </button>
                  <!-- دکمه چاپ لیبل آدرس (انتقال یافته از کارت شعبه) -->

                  <!-- دکمه‌های تایید/عدم تایید کل سفارش (قبلاً بالای لیست کارت‌ها بود) -->
                  <button
                    v-if="
                      order.flowStepStatusId == 4 &&
                        !$store.state.userData.isOrganization &&
                        !$store.state.userData.isPishkhan
                    "
                    class="btn btn-success"
                    @click="confirmAndExecute('approveAll', true)"
                  >
                    تایید سفارش
                  </button>
                  <button
                    v-if="
                      order.flowStepStatusId == 4 &&
                        !$store.state.userData.isOrganization &&
                        !$store.state.userData.isPishkhan
                    "
                    class="btn btn-danger"
                    @click="confirmAndOpenModal('#reject-order')"
                  >
                    عدم تایید سفارش
                  </button>
                  <button
                    v-if="
                      order.flowStatusId == 270 &&
                        order.cardActivationPinSummary
                          .waitingForActivationCount == 0
                    "
                    class="btn btn-primary"
                    @click="confirmAndExecute('activate-cards')"
                  >
                    فعالسازی کارت های این سفارش
                  </button>
                  <button
                    v-if="$store.state.role == 'admin' && order.branchAddress"
                    class="btn btn-secondary"
                    @click="printLabel"
                  >
                    چاپ لیبل آدرس
                  </button>
                  <button
                    class="btn btn-success"
                    v-if="
                      order.orderItems[0].cardId &&
                        order.orderTypeId != 2 &&
                        $store.state.role == 'admin' &&
                        order.orderItems[0].getTrack
                    "
                    @click="getCardsDetails(order.orderItems[0].key)"
                  >
                    دریافت اطلاعات کارت‌ها
                  </button>
                </div>
              </div>
            </div>
            <div class="row col-7">
              <!-- =================  کارت هدیه ================= -->
              <div class="col-12" v-if="giftCardGroups.length">
                <div
                  v-for="giftCard in giftCardGroups"
                  :key="giftCard.key"
                  class="row mb-4"
                >
                  <div class="col-12">
                    <div class="creative-gift-card">
                      <div class="gift-card-bg-shape"></div>
                      <div class="row align-items-center ">
                        <div class="col-md-9">
                          <h4 class="gift-card-title">
                            {{
                              giftCard.item.theme
                                ? giftCard.item.theme.title
                                : "کارت هدیه با طرح دلخواه"
                            }}
                          </h4>
                          <div class="gift-card-details">
                            <div class="gift-card-count">
                              <i class="fas fa-layer-group"></i> تعداد کل:
                              <strong>{{ giftCard.count }}</strong>
                            </div>

                            <div class="gift-card-status-badge">
                              <span class="badge ">
                                وضعیت نمونه:
                                {{ getStatusText(giftCard.item.status) }}
                              </span>
                            </div>
                            <div
                              class="gift-card-status-badge"
                              v-if="giftCard.chargeAmount"
                            >
                              <span
                                class="badge bg-success "
                                style="color: whitesmoke;"
                              >
                                تعداد شارژ شده :
                                {{ giftCard.successfulCount }}
                              </span>
                            </div>
                            <div
                              class="gift-card-status-badge"
                              v-if="
                                giftCard.failedCount && giftCard.chargeAmount
                              "
                            >
                              <span
                                class="badge bg-warning"
                                style="color: whitesmoke;"
                              >
                                تعداد در انتظار شارژ :
                                {{ giftCard.failedCount }}
                              </span>
                            </div>
                            <div
                              class="gift-card-extra mt-2"
                              v-if="giftCard.item.showAmount !== undefined"
                            >
                              نمایش مبلغ روی کارت:
                              <strong>{{
                                giftCard.item.showAmount ? "بله" : "خیر"
                              }}</strong>
                            </div>
                            <div class="gift-card-extra mt-2">
                              <span class="">
                                مبلغ شارژ هر کارت:
                                <strong>
                                  {{
                                    new Intl.NumberFormat("en-IR", {
                                      maximumSignificantDigits: 20,
                                    }).format(giftCard.chargeAmount) + " ریال"
                                  }}
                                </strong>
                              </span>
                            </div>
                            <div
                              class="gift-card-text mt-2"
                              v-if="getGiftCardText(giftCard.item)"
                            >
                              <i class="fas fa-align-left"></i> متن روی کارت:
                              <strong>{{
                                getGiftCardText(giftCard.item)
                              }}</strong>
                            </div>
                          </div>
                          <div class="gift-card-actions mt-3">
                            <button
                              class="btn btn-sm btn-outline-primary ml-2"
                              v-if="!giftCard.item.themeId"
                              @click="
                                downloadOriginalImage(
                                  giftCard.item.cardMetadata.find(
                                    (cmd) => cmd.metadataKeyId === 81,
                                  ).downloadUrl,
                                )
                              "
                            >
                              دانلود تصویر اصلی کارت
                            </button>
                            <button
                              class="btn btn-sm btn-outline-secondary ml-2"
                              v-if="!giftCard.item.themeId"
                              @click="
                                downloadImageDirectly(giftCard.item.orderItemId)
                              "
                            >
                              دانلود تصویر کارت
                            </button>
                            <button
                              class="btn btn-sm btn-info"
                              v-if="
                                order.flowStepStatusId == 183 &&
                                  $store.state.role == 'bankpublicrelations'
                              "
                              @click="
                                enableEditCardItem(giftCard.item.orderItemId)
                              "
                            >
                              ویرایش طرح کارت
                            </button>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <!-- اسکلتون در حالت بارگذاری -->
                          <div
                            v-if="giftCardImageLoading[giftCard.key]"
                            class="gift-card-skeleton"
                          >
                            <div class="skeleton-image"></div>
                            <div class="skeleton-spinner"></div>
                          </div>
                          <!-- تصویر واقعی پس از بارگذاری -->
                          <img
                            v-else
                            :src="giftCardImages[giftCard.key]"
                            alt="Gift Card"
                            class="gift-card-thumbnail"
                            style="cursor: pointer"
                            @click="
                              openImageModal(giftCardImages[giftCard.key])
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row align-items-center p-2 px-3"
                  v-if="order.cardActivationPinSummary"
                >
                  <div
                    class="gift-card-extra mt-2"
                    v-if="order.cardActivationPinSummary.activatedCount"
                  >
                    تعداد کارت فعال شده :
                    <strong>{{
                      order.cardActivationPinSummary.activatedCount
                    }}</strong>
                  </div>
                  <div
                    class="gift-card-extra mt-2"
                    v-if="order.cardActivationPinSummary.failedActivationCount"
                  >
                    تعداد فعالسازی کارت ناموفق :
                    <strong>{{
                      order.cardActivationPinSummary.failedActivationCount
                    }}</strong>
                  </div>
                  <div
                    class="gift-card-extra mt-2"
                    v-if="
                      order.cardActivationPinSummary.waitingForActivationCount
                    "
                  >
                    تعداد کارت در انتظار فعال شدن :
                    <strong>{{
                      order.cardActivationPinSummary.waitingForActivationCount
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-5 g-4 align-self-start">
              <!-- 1.  اطلاعات شعبه -->
              <div class="col-12 mb-4">
                <div class="card card-order h-100">
                  <div class="card-header-custom">
                    <i class="fas fa-store"></i> اطلاعات شعبه
                  </div>
                  <div class="card-body-custom">
                    <div class="info-row">
                      <div class="info-label">شعبه سفارش‌دهنده:</div>
                      <div class="info-value">
                        {{ order.branchName || "" }}
                        {{ order.branchCode ? "-" + order.branchCode : "" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">کاربر ثبت‌کننده سفارش:</div>
                      <div class="info-value">
                        <span v-if="order.requester">
                          {{ order.requester.firstName || "" }}
                          {{ order.requester.lastName || "" }}
                        </span>
                        <span v-else>-</span>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">شماره همراه کاربر ثبت‌کننده:</div>
                      <div class="info-value">
                        <span
                          v-if="order.requester && order.requester.mobile"
                          class="phone-number"
                        >
                          {{ order.requester.mobile }}
                        </span>
                        <span v-else>-</span>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">کد پستی:</div>
                      <div class="info-value">
                        {{ order.branchZipCode || "-" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">تلفن تماس:</div>
                      <div class="info-value">
                        <div
                          v-if="order.branchPhoneAreaCode && order.branchPhone1"
                          class="phone-number"
                        >
                          {{ order.branchPhoneAreaCode }}-{{
                            order.branchPhone1
                          }}
                        </div>
                        |
                        <div
                          v-if="order.branchPhoneAreaCode && order.branchPhone2"
                          class="phone-number mt-1"
                        >
                          {{ order.branchPhoneAreaCode }}-{{
                            order.branchPhone2
                          }}
                        </div>
                        <span v-if="!order.branchPhone1 && !order.branchPhone2"
                          >-</span
                        >
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">آدرس شعبه :</div>
                      <div class="info-value">
                        {{ order.branchProvince || "" }}
                        {{ order.branchCity ? ". " + order.branchCity : "" }}
                        {{
                          order.branchAddress ? "، " + order.branchAddress : ""
                        }}
                        <span
                          v-if="
                            !order.branchProvince &&
                              !order.branchCity &&
                              !order.branchAddress
                          "
                          >-</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 2. اطلاعات مشتری -->
              <div class="col-md-6">
                <div class="card card-order h-100">
                  <div class="card-header-custom">
                    <i class="fas fa-user-circle"></i> اطلاعات مشتری
                  </div>
                  <div class="card-body-custom">
                    <div class="info-row">
                      <div class="info-label">نام مشتری:</div>
                      <div class="info-value">
                        {{
                          (order.domainMetadata.firstName || "") +
                            " " +
                            (order.domainMetadata.lastName || "") || "-"
                        }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">کد ملی مشتری:</div>
                      <div class="info-value">
                        {{ order.domainMetadata.nationalCode || "———" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">موبایل مشتری:</div>
                      <div class="info-value dir-ltr">
                        <span class="phone-number">{{
                          order.domainMetadata.mobile ||
                            order.customerMobile ||
                            "اطلاعاتی موجود نیست"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3. اطلاعات پرداخت (وضعیت مالی) -->
              <div class="col-md-6 ">
                <div class="card card-order h-100">
                  <div class="card-header-custom">
                    <i class="fas fa-credit-card"></i> اطلاعات پرداخت
                  </div>
                  <div class="card-body-custom">
                    <div class="info-row">
                      <div class="info-label">وضعیت پرداخت:</div>
                      <div class="info-value">
                        <span
                          :class="{
                            'text-success fw-bold':
                              order.paymentStatusTitle === 'پرداخت شده',
                            'text-warning':
                              order.paymentStatusTitle === 'در انتظار پرداخت',
                          }"
                          class="badge-status"
                          style="background:#e9ecef;"
                        >
                          {{ order.lastPayment.paymentStatusTitle || "نامشخص" }}
                        </span>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">وضعیت تایید مالی:</div>
                      <div class="info-value">
                        <span
                          class="badge-status"
                          :class="{ 'text-success': order.financeVerify }"
                          >{{
                            order.financeVerify ? "تاییده شده" : "تایید نشده"
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="info-row" v-if="order.financeVerify">
                      <div class="info-label">تأییدکننده مالی:</div>
                      <div class="info-value">
                        <span
                          v-if="
                            order.financeVerify === true &&
                              order.financeVerifier
                          "
                        >
                          {{ order.financeVerifier }}
                        </span>
                        <span v-else class="text-muted">—</span>
                      </div>
                    </div>
                    <div class="info-row" v-if="order.financeVerify">
                      <div class="info-label">زمان تأیید مالی:</div>
                      <div class="info-value">
                        {{ order.financeVerifyDateTime || "——" }}
                        <span
                          v-if="!order.financeVerifyDateTime"
                          class="text-muted-custom fst-italic"
                          >ثبت نشده</span
                        >
                      </div>
                    </div>
                    <div
                      v-if="
                        order.description && order.description.trim() !== ''
                      "
                      class="alert alert-warning mt-2 py-2 px-2 small"
                    >
                      توضیحات: {{ order.description }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- 4. اطلاعات سفارش -->
              <div class="col-md-6 mt-4 order-info-column">
                <div class="card card-order">
                  <div class="card-header-custom">
                    <i class="fas fa-receipt"></i> اطلاعات سفارش
                  </div>
                  <div class="card-body-custom">
                    <div class="info-row">
                      <div class="info-label">شماره سفارش:</div>
                      <div class="info-value fw-bold">
                        {{ order.orderId || "---" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">سفارش:</div>
                      <div class="info-value">
                        <span class="badge-status">{{
                          order.statusTitle || "نامشخص"
                        }}</span>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">نوع سفارش</div>
                      <div class="info-value">{{ order.orderType }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">تاریخ ثبت سفارش:</div>
                      <div class="info-value">
                        {{ order.createdAtPersian || "---" }}
                      </div>
                    </div>
                    <div class="info-row" v-if="order.additionalData1">
                      <div class="info-value" style="width: 100% !important;">
                        {{ order.additionalData1 }}
                      </div>
                    </div>
                    <div class="info-row" v-if="order.additionalData2">
                      <div class="info-value" style="width: 100% !important;">
                        {{ order.additionalData2 }}
                      </div>
                    </div>
                    <div class="info-row" v-if="order.additionalData3">
                      <div class="info-value" style="width: 100% !important;">
                        {{ order.additionalData3 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 5. کارت پرداخت (جایگزین جدول) -->
              <div
                class="col-md-6 mt-4 last-payment-column"
                v-if="transactions.length"
              >
                <div class="card card-order">
                  <div class="card-header-custom">
                    <i class="fas fa-money-bill-wave"></i> آخرین پرداخت
                  </div>
                  <div
                    class="card-body-custom"
                    v-for="(transaction, idx) in transactions"
                    :key="idx"
                  >
                    <div class="info-row">
                      <div class="info-label">مبلغ:</div>
                      <div class="info-value">
                        {{
                          new Intl.NumberFormat("en-IR", {
                            maximumSignificantDigits: 20,
                          }).format(transaction.amount) + " ریال"
                        }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">شماره مرجع:</div>
                      <div class="info-value">
                        {{ transaction.trRrn || "-" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">شماره پیگیری:</div>
                      <div class="info-value">
                        {{ transaction.trPaymentid || "-" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">وضعیت:</div>
                      <div class="info-value">
                        <span class="badge badge-success">موفق</span>
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">تاریخ:</div>
                      <div class="info-value">
                        {{
                          new Date(transaction.createdAt).toLocaleTimeString(
                            "fa-ir",
                          ) +
                            " - " +
                            new Date(transaction.createdAt).toLocaleDateString(
                              "fa-ir",
                            )
                        }}
                      </div>
                    </div>
                    <div class="info-row" v-if="transaction.receiptId">
                      <div class="info-label">تصویر رسید:</div>
                      <div class="info-value">
                        <a
                          @click="openReceipts(transaction.transactionId)"
                          target="_blank"
                          style="cursor: pointer"
                          >کلیک کنید</a
                        >
                      </div>
                    </div>
                    <!-- عملیات مالی (در صورت نیاز) -->
                    <div
                      class="mt-2"
                      v-if="
                        transaction.transactionStatusId == 41 &&
                          $store.state.role == 'finance'
                      "
                    >
                      <button
                        class="btn btn-sm btn-success ml-1"
                        @click="
                          changeTransactionStatus(
                            true,
                            transaction.transactionId,
                          )
                        "
                      >
                        <i class="fa fa-check"></i> تایید
                      </button>
                      <button
                        class="btn btn-sm btn-danger"
                        @click="
                          changeTransactionStatus(
                            false,
                            transaction.transactionId,
                          )
                        "
                      >
                        <i class="fa fa-times"></i> رد
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ================= بخش ویرایش طرح کارت (بدون تغییر) ================= -->
          <div class="card mb-3" v-if="enableEditCard">
            <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">
              ویرایش طرح کارت
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <div
                    class="row create-cart-box justify-content-center text-center"
                    v-if="imageSrc"
                  >
                    <p class="w-100">تصویر مورد نظر خود را انتخاب کنید</p>
                    <div class="col-md-8 text-center">
                      <img id="image" :src="imageSrc" />
                    </div>
                  </div>
                  <div class="row justify-content-center text-center" v-else>
                    <p class="w-100 mb-4">تصویر مورد نظر خود را انتخاب کنید</p>
                    <div class="col-12 mb-4">
                      <div class="row">
                        <div class="col-md-3 text-right">
                          <label class="rdiobox"
                            ><input
                              name="rdio"
                              type="radio"
                              value="all"
                              v-model="imagesType"
                              checked
                            />
                            <span>همه تصاویر</span></label
                          >
                        </div>
                        <div class="col-md-3 text-right">
                          <label class="rdiobox"
                            ><input
                              name="rdio"
                              type="radio"
                              value="system"
                              v-model="imagesType"
                            />
                            <span>تصاویر پیشفرض</span></label
                          >
                        </div>
                        <div class="col-md-3 text-right">
                          <label class="rdiobox"
                            ><input
                              name="rdio"
                              type="radio"
                              value="user"
                              v-model="imagesType"
                            />
                            <span>تصاویر آپلود شده</span></label
                          >
                        </div>
                        <div class="col-md-3 text-right">
                          <label class="rdiobox"
                            ><input
                              name="rdio"
                              type="radio"
                              value="new"
                              v-model="imagesType"
                            />
                            <span>آپلود تصویر جدید</span></label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="imagesType != 'new'">
                      <div class="row" v-if="images.length || mainImageData">
                        <div class="col-md-4 mb-3">
                          <img
                            class="organization-image"
                            @click="setImageFile(mainImageData)"
                            :src="mainImageData"
                            alt=""
                          />
                        </div>
                        <div
                          class="col-md-4 mb-3"
                          v-for="(image, index) in images"
                          :key="index"
                        >
                          <img
                            class="organization-image"
                            @click="setImageId(image.mediaId)"
                            :src="
                              `https://cardapi.sabinarya.com/${image.picUrl}`
                            "
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="row" v-else>
                        <div class="col-md-12">
                          <div class="alert alert-info">
                            <p class="mb-0">تصویری یافت نشد</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-else>
                      <div
                        :style="{
                          display: currentStep == 1 ? 'unset' : 'none',
                        }"
                      >
                        <div
                          class="row create-cart-box justify-content-center"
                          v-if="imageSrc"
                        >
                          <div class="col-md-8 text-center">
                            <img id="image" :src="imageSrc" />
                            <button
                              class="btn btn-custom ml-1 mt-4 btn-dark"
                              @click="changeImage"
                            >
                              تغییر تصویر
                            </button>
                            <button
                              class="btn btn-primary btn-custom mt-4"
                              @click="currentStep++"
                            >
                              مرحله بعد
                            </button>
                          </div>
                        </div>
                        <div
                          class="row justify-content-center text-center"
                          v-else
                        >
                          <p class="w-100 mb-2">
                            تصویر مورد نظر خود را انتخاب کنید
                          </p>
                          <div class="mt-3 mb-2">
                            <label for="custom-file-upload" class="filupp">
                              <span class="filupp-file-name js-value"
                                >انتخاب تصویر</span
                              >
                              <input
                                type="file"
                                name="attachment-file"
                                value="1"
                                id="custom-file-upload"
                                @change="setImage"
                                accept="image/png,image/jpeg"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h6 class="custom-card-box-title">پیش نمایش</h6>
                  <hr class="mb-4" />
                  <div id="preview-parent">
                    <div id="preview-container" class="mt-3">
                      <img
                        src="/assets/img/giftcard.png"
                        class="card-template"
                      />
                      <div id="preview"></div>
                    </div>
                  </div>
                  <div class="form-group" v-if="imageSrc && madeImage">
                    <label>علت ویرایش طرح</label>
                    <input type="text" class="form-control" v-model="comment" />
                  </div>
                  <button
                    v-if="imageSrc && !madeImage"
                    :class="
                      !imageUrl
                        ? 'btn btn-custom ml-1 btn-dark mt-1'
                        : 'btn btn-custom ml-1 btn-dark mt-1'
                    "
                    @click="changeImage"
                  >
                    تغییر تصویر
                  </button>
                  <button
                    v-if="imageSrc && !madeImage"
                    :class="
                      !imageUrl
                        ? 'btn btn-success ml-1 btn-custom mt-1'
                        : 'btn btn-success ml-1 btn-custom mt-1'
                    "
                    @click="makeImage"
                    :disabled="editBtn"
                  >
                    تایید طرح
                  </button>
                  <button
                    v-if="imageSrc && madeImage"
                    :class="
                      !imageUrl
                        ? 'btn btn-success ml-1 btn-custom mt-1'
                        : 'btn btn-success ml-1 btn-custom mt-1'
                    "
                    @click="updateOrderItem(orderItemId, cardMetadataId)"
                  >
                    ثبت تغییرات
                  </button>
                  <button class="btn btn-danger mt-1" @click="disableEditCard">
                    لغو تغییرات
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- سایر بخش‌های قدیمی که حذف نشده‌اند (مثل کارت اضافی برای نوع سفارش خاص) -->
          <div
            class="row"
            v-if="order.orderTypeId == 143 && $store.state.role == 'admin'"
          >
            <div class="col-12">
              <div class="card mb-3">
                <div
                  class="card-header p-3 tx-medium my-auto tx-white bg-gray-800"
                >
                  عملیات و جزئیات
                </div>
                <div class="card-body">
                  <p v-if="order.additionalData1">
                    {{ order.additionalData1.split(":")[0] }}:
                    <span dir="ltr">{{
                      order.additionalData1.split(":")[1]
                    }}</span>
                  </p>
                  <p v-if="order.additionalData2">
                    {{ order.additionalData2 }}
                  </p>
                  <button
                    class="btn btn-success btn-block"
                    data-target="#reissue"
                    data-toggle="modal"
                    v-if="order.flowStepStatusId == 245"
                  >
                    ثبت اطلاعات کارت جدید
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- لینک پیگیری پست و کد رهگیری -->
          <div
            class="row"
            v-if="order.trackingCode && order.flowStepStatusId == 8"
          >
            <div class="col-12">
              <a
                class="btn btn-warning mb-3 btn-block py-3"
                href="https://tracking.post.ir"
                target="_blank"
                >پیگیری مرسوله</a
              >
              <div class="alert alert-warning">
                <p class="mb-0">{{ order.trackingCode }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- مودال‌ها (بدون تغییر) -->
    <div class="modal effect-scale" id="reject" aria-hidden="true">...</div>
    <div class="modal effect-scale" id="finance-reject" aria-hidden="true">
      ...
    </div>
    <div class="modal effect-scale" id="reissue" aria-hidden="true">...</div>
    <div class="modal effect-scale" id="refound" aria-hidden="true">...</div>
    <div class="modal effect-scale" id="cards-pans" aria-hidden="true">...</div>

    <!-- مودال نمایش بزرگ تصویر کارت هدیه -->
    <div
      class="modal fade"
      id="giftCardImageModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">تصویر کارت هدیه</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="بستن"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img
              :src="enlargedImageSrc"
              class="img-fluid"
              alt="تصویر بزرگ کارت هدیه"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
/* ... (استایل‌ها بدون تغییر) ... */
body,
.card-body-custom,
.info-label,
.info-value,
.btn {
  font-size: 0.85rem;
}

.card-order {
  border: none;
  border-radius: 1.25rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  background: #ffffff;
}
.card-order:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.08);
}
.card-header-custom {
  background: linear-gradient(135deg, #1e2a5e 0%, #14203e 100%);
  color: white;
  font-weight: 600;
  border-radius: 1.25rem 1.25rem 0 0 !important;
  padding: 0.9rem 1.25rem;
  font-size: 0.95rem;
}
.card-header-custom i {
  margin-left: 8px;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #ffd966, #ffb347);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.card-body-custom {
  padding: 1rem;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.6rem;
  border-bottom: 1px dashed #e9ecef;
  padding-bottom: 0.5rem;
}
.info-label {
  width: 38%;
  font-weight: 600;
  color: #2c3e66;
  font-size: 0.8rem;
}
.info-value {
  width: 62%;
  color: #1f2b48;
  font-weight: 500;
  word-break: break-word;
  font-size: 0.85rem;
}
.badge-status {
  background-color: #eef2ff;
  color: #1e3a8a;
  padding: 0.2rem 0.5rem;
  border-radius: 50px;
  font-size: 0.7rem;
  font-weight: 500;
}
.phone-number {
  direction: ltr;
  display: inline-block;
  font-family: monospace;
  letter-spacing: 0.5px;
}
.order-info-column,
.last-payment-column {
  align-self: flex-start;
}

/* کارت خلاقانه هدیه */
.creative-gift-card {
  position: relative;
  background: linear-gradient(125deg, #fff8f0 0%, #fff0e0 100%);
  border-radius: 2rem;
  padding: 1.5rem;
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 200, 100, 0.4);
  min-height: 160px;
}
.creative-gift-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 28px 40px -16px rgba(0, 0, 0, 0.25);
}
.gift-card-bg-shape {
  position: absolute;
  top: -30%;
  right: -10%;
  width: 220px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(255, 215, 130, 0.3) 0%,
    rgba(255, 190, 70, 0) 70%
  );
  border-radius: 50%;
  pointer-events: none;
}
.gift-card-thumbnail {
  position: absolute;
  left: 0;
  top: -50px;
  max-width: 185px;
  border-radius: 1.5rem;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
  background: white;
  padding: 5px;
}
.gift-card-title {
  font-weight: 800;
  color: #7a4b0e;
  margin-bottom: 0.75rem;
  font-size: 1.3rem;
}
.gift-card-details {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: baseline;
}
.gift-card-count {
  background: #ffefcf;
  padding: 0.3rem 1rem;
  border-radius: 40px;
  font-size: 0.85rem;
  color: #a16200;
}
.gift-card-status-badge .badge {
  background-color: #fff3e0;
  color: #b95f00;
  font-size: 0.75rem;
  padding: 0.35rem 0.9rem;
}
/* .gift-card-status-badge .badge-success {
  background-color: #fff3e0;

  color: rgb(57, 168, 57);
}
.gift-card-status-badge .badge-danger {
  background-color: red;

  color: white;
} */
.gift-card-actions .btn {
  font-size: 0.75rem;
  padding: 0.3rem 0.9rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gift-card-text {
  background: #fff0d4;
  padding: 0.3rem 1rem;
  border-radius: 40px;
  font-size: 0.85rem;
  color: #9b4b00;
  width: 100%;
  direction: rtl;
  text-align: right;
}
.gift-card-text i {
  margin-left: 5px;
}
.gift-card-skeleton {
  position: absolute;
  left: 0;
  top: -50px;
  width: 185px;
  height: 120px;
  background: #f0f0f0;
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.skeleton-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 1.5rem;
}
.skeleton-spinner {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: #ffb347;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .info-label {
    width: 45%;
  }
  .info-value {
    width: 55%;
  }
  .creative-gift-card .col-md-3 {
    margin-bottom: 1rem;
  }
}
</style>

<script>
import Cropper from "cropperjs";
import html2canvas from "html2canvas";
import groupGiftCardItems from "../../utils/giftCardGroups";
export default {
  name: "Single",
  data() {
    return {
      showLoading: true,
      showModalLoading: false,
      paymentIdentifier: "",
      rrn: "",
      amount: 0,
      file: "",
      discount: null,
      deposit: 0,
      description: "",
      returns: [],
      flows: [],
      returnId: 0,
      token: "",
      returnDescription: "",
      enableEditCard: false,
      allImages: [],
      images: [],
      cardTypes: [],
      providers: [],
      rePan: "505785",
      reMonth: "",
      reYear: "",
      reCvv2: "",
      reCType: "",
      reIssuer: "",
      imagesType: "all",
      currentStep: 1,
      orderItemId: 0,
      cardMetadataId: 0,
      imageSrc: "",
      imageUrl: "",
      comment: "",
      mainImageData: "",
      orderItemDescription: "",
      financeRejectDescription: "",
      transactions: [],
      editBtn: false,
      madeImage: false,
      order: {},
      enlargedImageSrc: "",
      giftCardImages: {},
      giftCardImageLoading: {},
      giftCardObjectUrls: {},
    };
  },
  computed: {
    giftCardGroups() {
      return groupGiftCardItems(this.order.orderItems);
    },
  },
  methods: {
    // متد کمکی برای نمایش پیام تأیید و باز کردن مودال
    confirmAndOpenModal(modalId) {
      this.$swal({
        title: "هشدار",
        text: "آیا از انجام این عملیات اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          $(modalId).modal("show");
        }
      });
    },
    // متد کمکی برای اجرای مستقیم عملیات پس از تأیید
    confirmAndExecute(action, ...args) {
      console.log(action);
      let title = "هشدار";
      let text = "آیا از انجام این عملیات اطمینان دارید؟";
      this.$swal({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          switch (action) {
            case "approvePR":
              this.publicRelationsApprove(1);
              break;
            case "customerApprove":
              this.customerApprove(args[0]);
              break;
            case "financialApprove":
              this.financialApprove();
              break;
            case "sent":
              this.sent();
              break;
            case "delivered":
              this.delivered();
              break;
            case "notDelivered":
              this.notDelivered();
              break;
            case "activate-cards":
              this.activateCards();
              break;
            case "approveAll":
              this.approveOrRejectAll(args[0]);
              break;
            default:
              break;
          }
        }
      });
    },
    getBaseData() {
      this.$api.get("Cards/Types").then(({ data }) => {
        this.cardTypes = data.result;
      });
      this.$api.get("Organizations/Issuers").then(({ data }) => {
        if (data.status) this.providers = data.result;
      });
    },
    reissue() {
      this.showModalLoading = true;
      const postedData = {
        pan: this.rePan.replace(/-/g, ""),
        expMonth: this.reMonth,
        expYear: this.reYear,
        cvv2: this.reCvv2,
        orderId: this.$route.params.id,
        cardTypeId: this.reCType,
        issuerId: this.reIssuer,
      };
      this.$api
        .post("Orders/RegenrateSubmit", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              icon: "success",
              title: "تبریک",
              text: "عملیات با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              this.getData();
            });
        })
        .finally(() => {
          this.showModalLoading = false;
        });
    },
    enableEditCardItem(orderItemId) {
      this.orderItemId = orderItemId;
      this.enableEditCard = true;
    },
    getStatusText(statusId) {
      const map = {
        1: "در انتظار بررسی",
        2: "تایید شده",
        3: "عدم تایید",
        4: "پرداخت نشده",
        5: "شارژ شده",
      };
      return map[statusId] || "نامشخص";
    },
    disableEditCard() {
      this.enableEditCard = false;
      this.imageSrc = "";
      this.imageUrl = "";
      if (document.getElementsByClassName("cropper-container")[0])
        document.getElementsByClassName("cropper-container")[0].remove();
      if (document.getElementById("preview").childNodes[0])
        document.getElementById("preview").childNodes[0].remove();
    },

    setImageFile(data) {
      this.imageSrc = data;
      this.mainImageData = data;
      setTimeout(() => {
        const image = document.getElementById("image");
        if (image) {
          new Cropper(image, {
            aspectRatio: 91.0 / 58.0,
            viewMode: 1,
            preview: "#preview",
            autoCropArea: 0.8,
            dragMode: "move",
          });
        }
      }, 100);
    },
    customerApprove(state) {
      this.showLoading = true;
      const postedData = {
        orderId: this.$route.params.id,
        flowStatusId: state == 1 ? 307 : 291,
      };
      this.$api
        .post("Branches/Order/ChangeStatus", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              icon: "success",
              title: "تبریک",
              text: "عملیات با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              this.getData();
            });
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    openImageModal(imageSrc) {
      this.enlargedImageSrc = imageSrc;
      $("#giftCardImageModal").modal("show");
    },
    setImage(e) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
        this.mainImageData = e.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
      setTimeout(() => {
        const image = document.getElementById("image");
        if (image) {
          new Cropper(image, {
            aspectRatio: 91.0 / 58.0,
            viewMode: 1,
            preview: "#preview",
            autoCropArea: 0.8,
            dragMode: "move",
          });
        }
      }, 100);
    },
    async setImageId(id) {
      const result = await this.$api.get("Organizations/Media/" + id);
      this.imageSrc = "data:image/jpeg;base64," + result.data.base64;
      this.mainImageData = "data:image/jpeg;base64," + result.data.base64;
      setTimeout(() => {
        const image = document.getElementById("image");
        if (image) {
          new Cropper(image, {
            aspectRatio: 91.0 / 58.0,
            viewMode: 1,
            preview: "#preview",
            autoCropArea: 0.8,
            dragMode: "move",
          });
        }
      }, 100);
    },
    makeImage() {
      this.editBtn = false;
      document.getElementById("preview-container").style.transform = "unset";
      html2canvas(document.getElementById("preview-container")).then(
        (canvas) => {
          this.imageUrl = canvas.toDataURL("image/png");
        },
      );
      document.getElementById("preview-container").style.transform =
        "scale(0.32)";
      this.editBtn = true;
      this.madeImage = true;
    },
    getGiftCardText(item) {
      if (!item || !item.cardMetadata) return "";

      const textMeta = item.cardMetadata.find((cmd) => cmd.metadataKeyId === 3);
      return textMeta ? textMeta.textValue : "";
    },
    async fetchGiftCardImage(giftCard) {
      this.$set(this.giftCardImageLoading, giftCard.key, true);

      try {
        const item = giftCard.item;
        if (!item) return;

        let imageUrl = "";
        let isTheme = false;

        if (item.theme) {
          imageUrl = "https://cardapi.sabinarya.com" + item.theme.address;
          isTheme = true;
        } else {
          const cardImageMeta = item.cardMetadata.find(
            (cmd) => cmd.metadataKeyId === 2,
          );
          if (cardImageMeta && cardImageMeta.downloadUrl) {
            imageUrl =
              "https://cardapi.sabinarya.com" + cardImageMeta.downloadUrl;
          } else if (cardImageMeta && cardImageMeta.value) {
            this.$set(
              this.giftCardImages,
              giftCard.key,
              "data:image/png;base64," + cardImageMeta.value,
            );
            this.$set(this.giftCardImageLoading, giftCard.key, false);
            return;
          } else {
            throw new Error("آدرس تصویر یافت نشد");
          }
        }

        if (isTheme) {
          this.$set(this.giftCardImages, giftCard.key, imageUrl);
          this.$set(this.giftCardImageLoading, giftCard.key, false);
        } else {
          const response = await this.$api.get(imageUrl, {
            responseType: "blob",
          });
          const objectUrl = URL.createObjectURL(response.data);
          this.$set(this.giftCardObjectUrls, giftCard.key, objectUrl);
          this.$set(this.giftCardImages, giftCard.key, objectUrl);
          this.$set(this.giftCardImageLoading, giftCard.key, false);
        }
      } catch (error) {
        console.error("خطا در بارگیری تصویر کارت:", error);
        this.$set(this.giftCardImageLoading, giftCard.key, false);
        this.$set(
          this.giftCardImages,
          giftCard.key,
          "/path/to/placeholder.png",
        );
      }
    },
    updateOrderItem(orderItemId, oldMetaDataId) {
      this.showLoading = true;
      this.enableEditCard = false;
      let metadatas = [
        {
          key: 2,
          base64: this.imageUrl,
        },
        {
          key: 81,
          base64: this.mainImageData,
        },
      ];
      const postedData = {
        orderId: this.$route.params.id,
        metadatas,
        orderItemId,
        comment: this.comment,
        oldCardMetaDataId: oldMetaDataId,
      };
      this.$api
        .post("Branches/Item/Edit", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              icon: "success",
              title: "تبریک",
              text: "تغییر طرح کارت با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              this.imagesType = "all";
              this.currentStep = 1;
              this.imageSrc = "";
              this.imageUrl = "";
              this.comment = "";
              this.editBtn = false;
              this.madeImage = false;
              this.getData();
            });
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    setToken() {
      this.$api
        .post("Management/Card/VerifyToken", { otpCode: this.token.toString() })
        .then(({ data }) => {
          if (data.result) {
            this.$store.state.adminToken = this.token;
            this.$store.state.adminTokenExpireTime =
              new Date().getTime() + 5 * 60 * 1000;
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "کد اعتبارسنجی با موفقیت ثبت شد",
            });
            $("#cards-pans").modal("toggle");
          } else
            this.$swal({
              title: "خطا",
              icon: "error",
              text: "کد وارد شده اشتباه است",
            });
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    publicRelationsApprove(status) {
      this.showLoading = true;
      if (status == 1) {
        this.$api
          .post("Branches/Order/Approve", { orderId: this.$route.params.id })
          .then(({ data }) => {
            if (data.status)
              this.$swal({
                icon: "success",
                title: "تبریک",
                text: "تایید کارت با موفقیت انجام شد",
                confirmButtonText: "متوجه شدم",
              }).then(() => {
                this.getData();
              });
          })
          .finally(() => {
            this.showLoading = false;
          });
      } else {
        this.$api
          .post("Branches/Order/Reject", {
            orderId: this.$route.params.id,
            comment: this.description,
          })
          .then(({ data }) => {
            if (data.status)
              this.$swal({
                icon: "success",
                title: "تبریک",
                text: "عدم تایید کارت با موفقیت انجام شد",
                confirmButtonText: "متوجه شدم",
              }).then(() => {
                this.getData();
              });
          })
          .finally(() => {
            this.showLoading = false;
          });
      }
      this.description = "";
    },
    openReceipts(id) {
      window.open(
        "https://cardapi.sabinarya.com/api/v1/Management/Receipts/" + id,
      );
    },
    activateCards() {
      console.log("first");
      this.$api
        .post(
          `Orders/${parseInt(this.$route.params.id)}/ActivateAndChangePin`,
          {},
        )
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "موفق",
              text: data.result.message,
            });
          }
        });
    },
    printLabel() {
      localStorage.setItem("branchOrderId", this.$route.params.id);
      setTimeout(() => {
        const routeData = this.$router.resolve({ name: "bankBranches.label" });
        window.open(routeData.href, "_blank");
      }, 500);
    },
    getCardsDetails(key) {
      this.showLoading = true;
      const postedData = {
        orderId: parseInt(this.$route.params.id),
      };
      this.$api
        .post("Management/Orders/ExportCardSheet", postedData)
        .then(({ data }) => {
          let a = window.document.createElement("a");
          a.setAttribute(
            "href",
            "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
              data.result.fileName,
          );
          let fileName = data.result.fileName;
          a.setAttribute("download", fileName);
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    async getData() {
      this.showLoading = true;
      this.getTransactions();
      this.$api.get("Management/Returns").then(({ data }) => {
        this.returns = data.result;
      });
      this.$api.get("Organizations/Media?Option=2").then(({ data }) => {
        if (data.status && data.result.length) {
          this.images = data.result.filter(
            (image) => image.metadataKeyId == 2 && image.isApproved,
          );
          this.allImages = data.result.filter(
            (image) => image.metadataKeyId == 2 && image.isApproved,
          );
          let texts = [];
          data.result.map((text) => {
            if (text.metadataKeyId == 3 && text.isApproved)
              texts.push({
                ...text,
                value: text.text,
              });
          });
          this.texts = texts;
        }
      });
      if (this.$store.state.userData.isOrganization) {
        this.$api.get("Organizations/Wallet/Balance").then(({ data }) => {
          if (data.status)
            this.deposit = new Intl.NumberFormat("en-IR", {
              maximumSignificantDigits: 20,
            }).format(data.result);
        });
      }
      this.$api
        .get("Orders/" + this.$route.params.id)
        .then(({ data }) => {
          let orderItems = [];
          data.result.orderItems.map((item) => {
            if (!item.themeId) {
              let orderItemImage = item.cardMetadata.filter(
                (meta) => meta.metadataKeyId == 2,
              )[0];
              let orderItemMainImage = item.cardMetadata.filter(
                (meta) => meta.metadataKeyId == 81,
              )[0];
              this.mainImageData =
                "data:image/png;base64," +
                (orderItemMainImage ? orderItemMainImage.value : "");
              this.cardMetadataId = orderItemImage.cardMetadataId;
              this.orderItemDescription = orderItemImage.description;
              orderItems.push({
                ...item,
                imageUrl: "data:image/png;base64," + orderItemImage.value,
              });
            } else
              orderItems.push({
                ...item,
              });
          });
          this.order = data.result;
          this.order.orderItems = orderItems;
          Object.keys(this.giftCardObjectUrls).forEach((key) => {
            URL.revokeObjectURL(this.giftCardObjectUrls[key]);
          });
          this.giftCardImages = {};
          this.giftCardImageLoading = {};
          this.giftCardObjectUrls = {};
          this.giftCardGroups.forEach((giftCard) => {
            this.fetchGiftCardImage(giftCard);
          });
        })
        .finally(() => {
          this.showLoading = false;
        });
      await this.$api.get("Flows/" + 2).then(({ data }) => {
        let flows = data.result;
        let finalFlows = [];
        let subFlows = {};
        flows.map((flow) => {
          subFlows = {};
          flow.flowStepStatuses.map((flowStep) => {
            subFlows[flowStep.flowStepStatusId] = flowStep.title;
          });
          finalFlows.push({
            title: flow.title,
            sort: flow.sort,
            subFlows,
          });
        });
        this.flows = finalFlows;
      });
    },
    getTransactions() {
      this.$api
        .post("Management/Transactions", {
          orderId: parseInt(this.$route.params.id),
        })
        .then(({ data }) => {
          if (data.transactions) this.transactions = data.transactions;
        });
    },
    beforeDestroy() {
      Object.keys(this.giftCardObjectUrls).forEach((key) => {
        URL.revokeObjectURL(this.giftCardObjectUrls[key]);
      });
    },
    changeImage() {
      this.imageSrc = "";
      this.imageUrl = "";
      if (document.getElementsByClassName("cropper-container")[0])
        document.getElementsByClassName("cropper-container")[0].remove();
      if (document.getElementById("preview").childNodes[0])
        document.getElementById("preview").childNodes[0].remove();
    },
    downloadImage(base64) {
      let image = new Image();
      image.src = base64;
      let newWindow = window.open("");
      newWindow.document.write(image.outerHTML);
    },
    async downloadOriginalImage(downloadUrl) {
      const url = `https://cardapi.sabinarya.com/${downloadUrl}`;
      try {
        const response = await this.$api.get(url, {
          responseType: "blob",
        });
        const blob = response.data;
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = `original_card_${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      } catch (error) {
        console.error("خطا در دانلود تصویر اصلی:", error);
      }
    },
    downloadImageDirectly(itemId) {
      window.open(
        "https://cardapi.sabinarya.com/api/v2/Metadata/Download?orderItemId=" +
          itemId,
      );
    },
    financialReject() {
      this.showLoading = true;
      this.$api
        .post("Management/FinancialApprove", {
          orderId: parseInt(this.$route.params.id),
          confirm: false,
          description: this.financeRejectDescription,
        })
        .then(({ data }) => {
          this.showLoading = false;
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "عدم تایید مالی سفارش با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    financialApprove() {
      this.showLoading = true;
      this.$api
        .post("Management/FinancialApprove", {
          orderId: parseInt(this.$route.params.id),
          confirm: true,
        })
        .then(({ data }) => {
          this.showLoading = false;
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "تایید مالی درخواست با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    approveOrRejectAll(approve) {
      this.$swal({
        title: "هشدار",
        text: "از انجام این کار اطمینان دارید ؟",
        icon: "warning",
        confirmButtonText: "تایید",
        showCancelButton: true,
        cancelButtonText: "لغو",
      }).then((res) => {
        if (res.isConfirmed) {
          this.showLoading = true;
          const postedData = {
            orderId: this.$route.params.id,
            approve,
          };
          if (this.discount) postedData.discount = this.discount;
          if (!approve) postedData.description = this.description;
          this.$api
            .post("Organizations/Bonus/Order/Approve", postedData)
            .then(({ data }) => {
              if (data.status) {
                this.$swal({
                  title: "تبریک",
                  icon: "success",
                  text:
                    "سفارش با موفقیت " +
                    (!approve ? "عدم تایید" : "تایید") +
                    " شد",
                  confirmButtonText: "متوجه شدم",
                });
                this.getData();
              }
            })
            .finally(() => {
              this.showLoading = false;
            });
        }
      });
    },
    numberFormat() {
      let value = this.amount.toString().replace(/,/g, "");
      value = new Intl.NumberFormat("en-IR", {
        maximumSignificantDigits: 20,
      }).format(value);
      if (value == "NaN") value = "";
      if (this.amount.toString().replace(/,/g, "") > this.order.totalAmount)
        this.amount = new Intl.NumberFormat("en-IR", {
          maximumSignificantDigits: 20,
        }).format(this.order.totalAmount);
      else this.amount = value;
    },
    returnOrder() {
      this.showLoading = true;
      const postedData = {
        orderId: parseInt(this.$route.params.id),
        description: this.returnDescription,
        returnId: this.returnId,
      };
      this.$api
        .post("Management/ReturnItems", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.showLoading = false;
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "ثبت مرجوعی با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async setFile(e) {
      const file = e.target.files[0];
      const finalFile = await this.toBase64(file);
      this.file = finalFile;
      document
        .getElementById("file-input")
        .setAttribute("placeholder", file.name);
    },
    submitPayment() {
      this.showLoading = true;
      const postedData = {
        paymentIdentifier: this.paymentIdentifier,
        rrn: this.rrn,
        amount: parseInt(this.amount.toString().replace(/,/g, "")),
        orderId: parseInt(this.$route.params.id),
        base64Receipt: this.file,
      };
      this.$api
        .post("Organizations/SubmitPayment", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.paymentIdentifier = this.amount = this.rrn = this.pansFile =
              "";
            document
              .getElementById("file-input")
              .setAttribute("placeholder", "");
            this.getData();
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "ثبت اطلاعات پرداخت با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            });
          }
        })
        .catch(({ response }) => {
          this.showLoading = false;
        });
    },
    payWithWallet() {
      this.showLoading = true;
      this.$api
        .post("Organizations/Bonus/Order/WalletPayment", {
          orderId: this.$route.params.id,
        })
        .then(({ data }) => {
          if (data.status) {
            this.getData();
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "پرداخت با موفقیت انجام شد",
              confirmButtonText: "متوجه شدم",
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    sent() {
      this.showLoading = true;
      const postedData = {
        orderId: parseInt(this.$route.params.id),
        flowStatusId: 347,
      };
      this.$api
        .post("Branches/Order/ChangeStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "وضعیت سفارش با موفقیت به روزرسانی شد",
              confirmButtonText: "متوجه شدم",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    chargeDeposit() {
      let amount =
        this.order.totalAmount -
        parseInt(this.deposit.toString().replace(/,/g, ""));
      localStorage.setItem("amount", amount);
      this.$router.push({ name: "organization.wallet" });
    },
    delivered() {
      this.showLoading = true;
      const postedData = {
        orderId: this.$route.params.id,
        flowStatusId: 270,
      };
      this.$api
        .post("Branches/Order/ChangeStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "وضعیت سفارش با موفقیت به روزرسانی شد",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              this.getData();
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    notDelivered() {
      this.showLoading = true;
      const postedData = {
        orderId: this.$route.params.id,
        flowStatusId: 388,
      };
      this.$api
        .post("Branches/Order/ChangeStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "وضعیت سفارش با موفقیت به روزرسانی شد",
              confirmButtonText: "متوجه شدم",
            }).then(() => {
              this.getData();
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    printCard(orderItem) {
      let cardId = orderItem.cardId;
      const postedData = {
        cardId: cardId,
        typeId: 58,
      };
      this.$api.post("Print/AddCommand", postedData).then(({ data }) => {
        if (data.status) {
          let gotData = data.result.command;
          this.$api
            .post(gotData.agentLocalAddress, gotData)
            .then((response) => {
              console.log(response);
            });
        }
      });
    },
  },
  created() {
    this.getData();
    this.getBaseData();
  },
};
</script>
